import React, { useMemo } from 'react'
import { textOperators } from '../../utils/constants/operators'
import ListModule from '../module/ListModule'

const UserSubModule = ({ userRight, user, location }) => {
  const columns = useMemo(
    () => [
      {
        name: 'firstname',
        label: 'Prénom',
        isFilter: true,
        operators: textOperators
      },
      {
        name: 'lastname',
        label: 'Nom',
        isFilter: true,
        operators: textOperators
      },
      {
        name: 'email',
        label: 'Email',
        isFilter: true,
        operators: textOperators
      }
    ],
    []
  )

  const options = useMemo(
    () => ({
      objectType: 'users',
      accessRight: userRight,
      actions: { go: true },
      paperStyle: { marginTop: '5px', marginBottom: '5px' },
      objectFilter: () => ({
        role_id: location.state?.id,
        company_id: user.company_id
      }),
      isExpand: false,
      columns
    }),
    [userRight, user?.company_id, location?.state?.id, columns]
  )

  const toolbar = useMemo(
    () => ({
      isFilter: true,
      isSubMod: true,
      columns,
      style: { marginTop: '5px', marginBottom: '5px' },
      objectType: 'users',
      accessRight: userRight,
      columnVisibility: true,
      getContext: () => ({ role_id: location.state.id })
    }),
    [columns, userRight]
  )

  return <ListModule options={options} toolbar={toolbar} />
}

export default React.memo(UserSubModule)
